import React from 'react'

import variables from '../../../variables.module.scss'

interface InlineCodeProps {
  children: string,
  color?: string
  bgColor?: string
  darkMode?: boolean
}

export const InlineCode: React.FC<InlineCodeProps> = ({ children, color = 'inherit', bgColor = variables.headerBackgroundColor, darkMode = false }) => {
  return (
    <code
      style={{
        background: darkMode ? variables.githubEditorBackgroundColor : bgColor,
        borderRadius: '4px',
        fontSize: '12px',
        padding: '2px 4px',
        border: `1px solid ${darkMode ? variables.slateColor : variables.dataBackgroundColor}`,
        verticalAlign: 'middle',
        color: darkMode ? variables.headerBackgroundColor : color
      }}
    >
      {children}
    </code>
  )
}
